// En hooks/api/useDeleteTemplate.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
import  api  from "../../services/axios";
import { useAppDispatch } from "../../store/hook/store.hook";
import { removeTemplate } from "../../store/slices/templates.slice"; // Asegúrate de tener esta acción

export const useDeleteTemplate = () => {
    const queryClient = useQueryClient();
    const dispatch = useAppDispatch();

    return useMutation({
        mutationFn: (id: number) =>
            api.delete(`/settings-app/templates/${id}`),
        onSuccess: (_, id) => {
            // Actualiza Redux
            dispatch(removeTemplate(id));

            // Invalida la caché de React Query
            queryClient.invalidateQueries({ queryKey: ['templates'] });
        }
    });
};